<!--
  蛋叔渠道 V2 规格弹窗

  作用：
  - DetailsDsV2 详情页打开本弹窗；
  设计要点：
  - 价格 / 单位严格走详情接口透传的 cardPointTypeUnit / isShowPrice，与老 SpecHeader 一致；
  - 商品 id 以 DS 开头：加购与立即购均须先选收货地址（无地址禁用加购按钮）；
  - 加购显隐仍受 computeShowAddcardFromRules 约束（仅快递+validate_same_row 可加购，自提 / 商家配送不可加购）；
  - 多规格 V2 拆单本组件仅支持单规格场景（详情进入加购 / 立即购，规格只选 1 条）；多规格拆单结算由购物车统一处理。
-->
<template>
  <div class="spec-wrapper">
    <OverlayLoad :show="overlayShow || distributionRulesLock"></OverlayLoad>
    <van-popup v-model="popupShow" position="bottom" @click-overlay="handleClose" safe-area-inset-bottom closeable
      :style="{ height: '90%' }">
      <div class="spec-content">
        <SpecHeader :selectedSpec="selectedSpec" :productName="detail.productName"></SpecHeader>
        <div class="spec-content-middle">
          <SpecLump>
            <div class="address-warpper">
              <div class="address-title">
                收货地址<span class="address-title-tip">(将影响商品是否可配送)</span>
              </div>
              <van-cell :title="addressInfo.address || '请添加收货地址'" icon="location-o" is-link @click="handleAddressOpen" />
            </div>
          </SpecLump>

          <SpecLump>
            <SpecListChoose :list="specList" @change="handleSpecUserChange"
              @loadAfter="handleSpecListReady"></SpecListChoose>
          </SpecLump>

          <SpecLump>
            <div class="field-wrapper">
              <div class="field-label">购买数量</div>
              <div class="field-content">
                <van-stepper :disable-minus="payCount <= 1" :disabled="!selectedSpec.id" disable-input
                  @overlimit="handleOverlimit" @change="onChange" v-model="payCount" />
              </div>
            </div>
          </SpecLump>

          <!-- 口味选择（来自 ds_product_spec_sync.third_tastes 逗号拆分；单条默认选中，多条单选） -->
          <SpecLump v-if="hasTastes">
            <div class="address-warpper">
              <div class="address-title">口味</div>
              <div class="taste-list">
                <span
                  v-for="(t, i) in tasteOptions"
                  :key="i"
                  class="taste-item"
                  :class="{ 'taste-item-selected': selectedTaste === t, 'taste-item-readonly': tasteOptions.length === 1 }"
                  @click="handleTasteClick(t)">{{ t }}</span>
              </div>
            </div>
          </SpecLump>

          <SpecLump v-if="hasChargeList">
            <div class="address-warpper">
              <div class="address-title">附件</div>
              <ChargeSelector :chargeList="detail.chargeList" @change="handleChargeChange" />
            </div>
          </SpecLump>

          <!-- 配送说明：配规 delivery_text 作为 van-cell #label，与结算页「方式下小字」风格一致 -->
          <SpecLump v-if="deliveryMethodLumpVisible">
            <div class="address-warpper">
              <div class="address-title">配送方式</div>
              <van-cell
                icon="logistics"
                :is-link="deliveryMethodCellIsLink"
                @click="handleOpenSendTypeClick"
              >
                <template #title>
                  <span class="spec-cell-primary">{{ deliveryHead }}</span><template v-if="deliveryTail">:{{ deliveryTail }}</template>
                </template>
                <template v-if="rulesDeliveryTextDisplay" #label>
                  <div class="spec-cell-delivery-note">{{ rulesDeliveryTextDisplay }}</div>
                </template>
              </van-cell>
            </div>
          </SpecLump>

          <SpecLump v-if="!noneAddressFlag && !noneSupportFlag && sendSelectType === 1">
            <div class="address-warpper">
              <div class="address-title">自提门店</div>
              <van-cell icon="shop-collect-o" is-link @click="shopAddressShow = true">
                <template #title>
                  <span class="spec-cell-primary">{{ (shopInfo && shopInfo.shopName) || '请选择自提门店' }}</span><template v-if="shopInfo && shopInfo.shopName && shopInfo.address">:{{ shopInfo.address }}</template>
                </template>
              </van-cell>
            </div>
          </SpecLump>

          <!-- 三方规格描述（辅助展示，selectedSpec.specDescription） -->
          <SpecLump v-if="hasSpecDesc">
            <div class="address-warpper">
              <div class="address-title">规格描述</div>
              <div class="aux-text">{{ selectedSpec.specDescription }}</div>
            </div>
          </SpecLump>

          <!-- 三方赠品说明（辅助展示，selectedSpec.gift） -->
          <SpecLump v-if="hasGift">
            <div class="address-warpper">
              <div class="address-title">赠品说明</div>
              <div class="aux-text">{{ selectedSpec.gift }}</div>
            </div>
          </SpecLump>

          <SpecLump v-if="canGreeting">
            <div class="address-warpper">
              <div class="address-title">祝福语</div>
              <div class="field-content">
                <van-field v-model="leaveWordText" left-icon="gift-card-o" rows="1" autosize type="textarea"
                  maxlength="20" :placeholder="leaveWordPlaceholder" show-word-limit
                  :disabled="noneAddressFlag || noneSupportFlag" />
              </div>
            </div>
          </SpecLump>

          <SpecLump v-if="canGreeting">
            <div class="address-warpper">
              <div class="address-title">备注</div>
              <div class="field-content">
                <van-field v-model="notesText" left-icon="notes-o" rows="1" autosize type="textarea" maxlength="200"
                  :placeholder="notesPlaceholder" :disabled="noneAddressFlag || noneSupportFlag" />
              </div>
            </div>
          </SpecLump>
        </div>

        <div class="pay-button-wrapper">
          <van-goods-action>
            <van-goods-action-button v-if="addCartShow" type="warning" :disabled="addCartButtonDisabled" :text="textCar"
              @click="handleAddMyCartClick" />
            <van-goods-action-button v-if="buyNowShow" type="danger" :disabled="buyNowButtonDisabled" :text="textBuy"
              @click="handlebuyNowClick" />
          </van-goods-action>
        </div>
      </div>
    </van-popup>

    <AddressPopup v-if="specDataLoad" ref="addressPopupRef" @change="handleSeleceAddressItem"
      @loadAfter="handleSeleceAddressItem"></AddressPopup>

    <SendType v-if="sendTypeShow" :columns="sendTypeColumns" @TypeConfirm="handleTypeConfirm"
      @TypeCancel="sendTypeShow = false" @closed="sendTypeShow = false"></SendType>

    <ShopAddress v-if="shopAddressShow" :shopList="shopList" @closed="shopAddressShow = false"
      @seleceShopItem="handleSelectShopChange"></ShopAddress>
  </div>
</template>

<script>
import { Toast } from "vant";
import SpecListChoose from "./SpecListChoose.vue";
import SpecLump from "./SpecLump.vue";
import SpecHeader from "./SpecHeader.vue";
import AddressPopup from "./AddressPopup.vue";
import OverlayLoad from "./OverlayLoad.vue";
import SendType from "../goods/SendType.vue";
import ShopAddress from "../goods/ShopAddress.vue";
import ChargeSelector from "../ChargeSelector/index.vue";
import { isLogin, isNoEmptyArr } from "./index.action";
import {
  queryDistributionRulesV2,
  computeShowAddcardFromRules,
  buildSendTypeColumns,
  resolveDeliveryInfoFromPick,
  loadV2Shops,
  stripDsPrefix,
} from "../../views/details/detailsDsV2.action";

/** 蛋叔商品无收货地址时：加购 / 立即购按钮文案与 Toast 统一 */
const DS_NEED_ADDRESS_HINT = "请先添加地址";

export default {
  name: "SpecPopupDsV2",
  components: { SpecListChoose, SpecLump, SpecHeader, AddressPopup, OverlayLoad, SendType, ShopAddress, ChargeSelector },
  props: {
    /** DsProductDetailV2VO（包含 thirdProductId / thirdBrandId / specList / mallCategory1Id / cardPointTypeUnit ...） */
    detail: {
      type: Object,
      default: () => ({}),
    },
    /** 详情接口的查询参数（cardId / cityCode / userId 等） */
    queryForm: {
      type: Object,
      default: () => ({ cardId: "", cityCode: "", userId: "" }),
    },
  },
  data() {
    return {
      popupShow: false,
      overlayShow: false,
      specDataLoad: false,
      sendTypeShow: false,
      shopAddressShow: false,
      // 弹窗模式：'addCart' / 'buyNow' / 'both'
      buyNowShow: true,
      addCartShow: true,
      textCar: "加入购物车",
      textBuy: "立即购买",
      cantBuy: true,

      // 规格 / 数量
      specList: [],
      selectedSpec: {},
      payCount: 1,

      // 地址（仅展示文案 + id；配送规则与 prePurchase 由后端按 addressId 查库）
      addressInfo: {
        address: "",
        addressId: "",
      },
      target: null, // 当前选中地址对象
      noneAddressFlag: false,
      noneSupportFlag: false,

      // 配送规则
      currentRulesGroup: null, // queryDistributionRulesV2 返回的第一个 group（含 rules / orderGroup）
      sendTypeColumns: [],
      deliveryInfo: { sendTypeStr: "", shipDate: "", shipTimeText: "", deliveryAmount: 0, shipType: "" },
      sendSelectType: 0, // 1 自提 / 2 快递 / 3 商家配送
      // 商家地址
      shopInfo: null,
      shopList: [],
      // 文本
      leaveWordText: "",
      notesText: "",
      leaveWordPlaceholder: "请输入祝福语，最多20个字",
      notesPlaceholder: "请输入需要备注的内容",
      // 锁
      distributionRulesLock: false,
      // 是否在结算页显示地址栏（与老逻辑同：1 显示，0 隐藏 — 蛋糕类不支持快递时隐藏）
      showAddressBar: 1,
      // 用户选择的附件（{chargeId, quantity, price}[]，仅含 quantity>0 的条目）
      chargeSelections: [],
      /**
       * 当前 selectedSpec 解析出的口味候选列表。
       * 单条默认选中且禁切换；多条用户单选。
       */
      tasteOptions: [],
      /** 当前用户选中的口味 */
      selectedTaste: "",
      // open() 时记录的按钮初始文案（refreshDistributionRulesV2 成功分支用于回填）
      _initialButtonTexts: { textBuy: "立即购买", textCar: "加入购物车" },
      // 本次弹窗打开入口: addCart / buyNow / both
      _openIntent: "both",
      /** 用户切换规格/数量：防抖与最小请求间隔，降低三方配送规则接口频控风险 */
      _rulesUserDebounceTimer: null,
      _rulesMinGapTimer: null,
      _lastRulesRequestCompletedAt: 0,
      RULES_USER_DEBOUNCE_MS: 450,
      RULES_MIN_INTERVAL_MS: 800,
    };
  },
  computed: {
    /**
     * 是否支持祝福语 / 备注。
     */
    canGreeting() {
      return Number(this.detail && this.detail.isGreeting) === 0 && this.detail.mallCategory1Id === '5'; // 5 为蛋糕类
    },
    /** 是否存在可选附件 */
    hasChargeList() {
      return Array.isArray(this.detail && this.detail.chargeList) && this.detail.chargeList.length > 0;
    },
    /** 当前规格是否有口味可选（>=1 条） */
    hasTastes() {
      return Array.isArray(this.tasteOptions) && this.tasteOptions.length > 0;
    },
    /** 当前规格是否有赠品说明 */
    hasGift() {
      return !!(this.selectedSpec && this.selectedSpec.gift);
    },
    /** 当前规格是否有规格描述（三方文案） */
    hasSpecDesc() {
      return !!(this.selectedSpec && this.selectedSpec.specDescription);
    },
    /** 蛋叔渠道商品：商品 id 以 DS 开头 */
    isDsChannelProduct() {
      const id = this.detail && (this.detail.thirdProductId);
      if (id == null || id === "") return false;
      return String(id).startsWith("DS");
    },
    /**
     * 配规接口 delivery_text（蛇形 / 驼峰均兼容），有地址且已拉到规则时展示。
     */
    rulesDeliveryTextDisplay() {
      const g = this.currentRulesGroup;
      const r = g && g.rules;
      if (!r) return "";
      const raw = r.delivery_text != null ? r.delivery_text : r.deliveryText;
      if (raw == null || raw === "") return "";
      const s = String(raw).trim();
      return s || "";
    },
    /** 有地址且（可配送 或 不可配送但有三方说明文案）时展示「配送方式」区块 */
    deliveryMethodLumpVisible() {
      if (this.noneAddressFlag) return false;
      if (this.noneSupportFlag) return !!this.rulesDeliveryTextDisplay;
      return true;
    },
    /** 主行标题：不可配送时固定文案，否则为已选方式摘要 */
    deliveryMethodCellTitle() {
      if (this.noneSupportFlag) return "不支持配送";
      return this.deliveryInfo.sendTypeStr || "请选择配送方式";
    },
    deliveryHead() {
      const s = this.deliveryMethodCellTitle || "";
      const i = s.indexOf(" ");
      return i > 0 ? s.slice(0, i) : s;
    },
    deliveryTail() {
      const s = this.deliveryMethodCellTitle || "";
      const i = s.indexOf(" ");
      return i > 0 ? s.slice(i + 1) : "";
    },
    /** 仅可配送且存在可选列时可点进选择器 */
    deliveryMethodCellIsLink() {
      return (
        !this.noneSupportFlag &&
        Array.isArray(this.sendTypeColumns) &&
        this.sendTypeColumns.length > 0
      );
    },
    /** 配规加载中 / 不支持配送时禁用；缺地址不禁用，便于点击后 Toast 并打开地址 */
    addCartButtonDisabled() {
      return this.distributionRulesLock || this.noneSupportFlag;
    },
    /** 配规加载中 / 不支持 / 未就绪时禁用；缺地址不禁用（与加购一致） */
    buyNowButtonDisabled() {
      return this.distributionRulesLock || this.noneSupportFlag || this.cantBuy;
    },
  },
  watch: {
    "detail.specList": {
      handler(newVal) {
        if (isNoEmptyArr(newVal)) {
          this.specList = newVal.map(s => this.toLegacySpec(s));
          if (!this.selectedSpec.id) {
            this.selectedSpec = this.specList[0];
          }
          // 切换详情数据时同步口味候选 + 默认选中策略
          this.applyTasteOptionsForSpec(this.selectedSpec);
        }
      },
      immediate: true,
    },
  },
  methods: {
    isSameSpec(recordA, recordB) {
      const idA = recordA && recordA.id;
      const idB = recordB && recordB.id;
      return !!idA && !!idB && String(idA) === String(idB);
    },

    /**
     * 把 V2 规格 VO 适配成老 SpecListChoose / SpecHeader 可识别的形态：
     * 复用老 UI 的 specifications / showPrice / coverImage / id 等字段。
     */
    toLegacySpec(s) {
      if (!s) return {};
      return {
        ...s,
        id: s.thirdSpecId, // 老组件以 id 作为唯一标识
        specifications: s.specName,
        showPrice: s.showPrice,
        coverImage: s.specImg || (this.detail && this.detail.imagePath) || "",
        cardPointTypeUnit: s.cardPointTypeUnit || (this.detail && this.detail.cardPointTypeUnit) || "点",
        isShowPrice: s.isShowPrice == null ? (this.detail && this.detail.isShowPrice) : s.isShowPrice,
        status: "1",
      };
    },

    open(typeStr, buttonTexts = {}) {
      if (!isLogin()) return;
      this._openIntent = typeStr || "both";
      this.cancelPendingUserRulesRefresh();

      // 重置交互状态(避免上次打开后残留 noneSupportFlag 等)
      this.noneAddressFlag = false;
      this.noneSupportFlag = false;
      this.deliveryInfo = { sendTypeStr: "", shipDate: "", shipTimeText: "", deliveryAmount: 0, shipType: "" };
      this.sendTypeColumns = [];
      this.sendSelectType = 0;
      this.currentRulesGroup = null;
      this.shopList = [];
      this.shopInfo = null;
      this.cantBuy = true;
      this.textBuy = "加载中...";
      this.textCar = "加载中...";
      this._initialButtonTexts = {
        textBuy: buttonTexts.textBuy || "立即购买",
        textCar: buttonTexts.textCar || "加入购物车",
      };

      if (typeStr === "addCart") {
        this.buyNowShow = false;
        this.addCartShow = true;
      } else if (typeStr === "buyNow") {
        this.buyNowShow = true;
        this.addCartShow = false;
      } else {
        this.buyNowShow = true;
        this.addCartShow = true;
      }

      this.overlayShow = true;
      this.specDataLoad = true;
      setTimeout(() => {
        this.overlayShow = false;
        this.popupShow = true;
        this.$nextTick(() => {
          this.afterPopupFullyOpen();
        });
      }, 300);
    },

    /**
     * 弹层显示后：同步地址子组件（二次打开也会走 ensureDefaultSynced），由 loadAfter → handleSeleceAddressItem 统一拉配送规则。
     * 避免「规格 loadAfter 已因缓存地址打了一次规则」再叠加地址回调形成双请求（立即购买常见）。
     */
    async afterPopupFullyOpen() {
      await this.$nextTick();
      const ap = this.$refs.addressPopupRef;
      if (ap && typeof ap.ensureDefaultSynced === "function") {
        try {
          await ap.ensureDefaultSynced();
        } catch (e) {
          console.warn("ensureDefaultSynced 失败", e);
        }
      } else {
        await this.refreshDistributionRulesV2();
      }
    },

    handleClose() {
      this.cancelPendingUserRulesRefresh();
      this.popupShow = false;
    },

    cancelPendingUserRulesRefresh() {
      if (this._rulesUserDebounceTimer) {
        clearTimeout(this._rulesUserDebounceTimer);
        this._rulesUserDebounceTimer = null;
      }
      if (this._rulesMinGapTimer) {
        clearTimeout(this._rulesMinGapTimer);
        this._rulesMinGapTimer = null;
      }
    },

    /**
     * 用户切换规格 / 数量时调度规则请求：防抖 + 两次成功请求之间最小间隔。
     * 地址变更、弹窗首次同步仍直接 await refreshDistributionRulesV2（不走本方法）。
     */
    scheduleUserTriggeredRulesRefresh() {
      if (!this.popupShow) return;
      if (this.distributionRulesLock) {
        Toast("正在获取配送规则，请稍等～");
        return;
      }
      this.cancelPendingUserRulesRefresh();
      this._rulesUserDebounceTimer = setTimeout(() => {
        this._rulesUserDebounceTimer = null;
        const run = () => {
          this.refreshDistributionRulesV2();
        };
        const now = Date.now();
        const since = now - (this._lastRulesRequestCompletedAt || 0);
        const minIv = this.RULES_MIN_INTERVAL_MS;
        if (this._lastRulesRequestCompletedAt > 0 && since < minIv) {
          this._rulesMinGapTimer = setTimeout(() => {
            this._rulesMinGapTimer = null;
            run();
          }, minIv - since);
          return;
        }
        run();
      }, this.RULES_USER_DEBOUNCE_MS);
    },

    handleAddressOpen(val) {
      if (this.distributionRulesLock) {
        Toast("正在获取配送规则，请稍等～");
        return;
      }
      if (this.$refs.addressPopupRef) {
        this.$refs.addressPopupRef.open(val);
      }
    },

    /**
     * AddressPopup 切换地址回调（含 loadAfter 默认地址首次加载场景）。
     */
    async handleSeleceAddressItem({ addressInfo, target }) {
      this.target = target || null;
      this.setAddresInfo(addressInfo, target);

      // 规格弹层未打开时（AddressPopup 在 open 前 mounted 会 getAddress）：只缓存地址，不拉规则，
      // 否则打开后 ensureDefaultSynced 再 emit loadAfter 会打第二次 queryDistributionRulesV2。
      if (!this.popupShow) {
        return;
      }

      if (!this.addressInfo.addressId) {
        this.noneAddressFlag = true;
        this.leaveWordPlaceholder = "请添加地址后再填写祝福语";
        this.notesPlaceholder = "请添加地址后再填写备注";
        await this.refreshDistributionRulesV2();
        return;
      }

      this.noneAddressFlag = false;
      this.leaveWordPlaceholder = "请输入祝福语，最多20个字";
      this.notesPlaceholder = "请输入需要备注的内容";

      await this.refreshDistributionRulesV2();
    },

    /**
     * 设置收货地址信息。
     *
     * 数据源优先级:
     * - target: AddressPopup addressList 中的完整 record(含 addressCname/addressQname/addressPname/addressQcode 等)
     * - record: AddressPopup 内部的 5 字段简化版(address/consigneeAddress/consigneeName/consigneePhone/addressId)
     * 设置收货地址展示与 id。配送规则 / prePurchase 仅传 addressId，由后端查 t_address 填充 cityName/area/addr/areaCode。
     */
    setAddresInfo(record, target) {
      if (!record && !target) {
        this.addressInfo = { address: "暂无收货地址点击添加地址", addressId: "" };
        return;
      }
      // 完整数据优先取 target;target 缺失则回落 record(此时只有简化 5 字段)
      const src = target || record || {};
      const fullAddrText =
        (src.addressCname || "") +
        (src.addressQname || "") +
        (src.addressPname || "") +
        (src.address || src.addr || "") +
        (src.houseNum || "");
      this.addressInfo = {
        address: (record && record.address) || fullAddrText,
        addressId: String(src.id != null ? src.id : (record && record.addressId) || ""),
      };
    },

    /**
     * 调 V2 配送规则；解析 → 渲染 SendType columns；处理加购/立即购禁用与文案。
     *
     * 状态流（每次调用顶部统一复位标志位，避免历史残留）:
     * - 无 selectedSpec.id      → 直接 return（规格未就绪）
     * - 无 addressInfo.addressId → noneAddressFlag=true, 文案"请先添加地址"
     * - 配送规则查询失败 / is_distribution=0 → noneSupportFlag=true, 文案"不支持配送"
     * - 可配送 → noneAddressFlag=false, noneSupportFlag=false, 渲染 columns + 默认值
     */
    async fetchDistributionRulesSnapshot(spec, quantity) {
      if (!spec || !spec.id) return { ok: false, reason: "noSpec" };

      const initialBuyText = (this._initialButtonTexts && this._initialButtonTexts.textBuy) || "立即购买";
      const initialCarText = (this._initialButtonTexts && this._initialButtonTexts.textCar) || "加入购物车";

      if (!this.addressInfo.addressId) {
        return {
          ok: false,
          reason: "noAddress",
          textBuy: DS_NEED_ADDRESS_HINT,
          textCar: DS_NEED_ADDRESS_HINT,
        };
      }

      const form = {
        addressId: String(this.addressInfo.addressId || ""),
        specIds: stripDsPrefix(spec.id),
        quantitys: String(quantity || 1),
      };
      const groups = await queryDistributionRulesV2(form, { silent: true });
      const first = groups[0];
      if (!first || !first.orderGroup || !first.orderGroup.isDistribution) {
        return {
          ok: false,
          reason: "notSupport",
          textBuy: "不支持配送",
          textCar: "不支持配送",
          // 仍带回 rules，便于展示 delivery_text（如节假日只接单不发货说明）
          currentRulesGroup: first || null,
        };
      }

      const og = first.orderGroup;
      const unit = (this.detail && this.detail.cardPointTypeUnit) || "点";
      const showAddcard = computeShowAddcardFromRules(first.rules);
      return {
        ok: true,
        reason: "ok",
        currentRulesGroup: first,
        sendTypeColumns: buildSendTypeColumns(og, unit),
        sendSelectType: og.sendSelectType,
        deliveryInfo: {
          shipType: og.shipType,
          shipDate: og.shipDate,
          shipTimeText: og.shipTimeText,
          deliveryAmount: og.deliveryAmount,
          sendTypeStr: this.composeDefaultSendTypeStr(og, unit),
        },
        showAddcard,
        textBuy: initialBuyText,
        textCar: initialCarText,
      };
    },

    applyRulesSnapshot(snapshot) {
      this.deliveryInfo = { sendTypeStr: "", shipDate: "", shipTimeText: "", deliveryAmount: 0, shipType: "" };
      this.sendTypeColumns = [];
      this.sendSelectType = 0;
      this.currentRulesGroup = null;
      this.shopList = [];
      this.shopInfo = null;
      this.cantBuy = true;
      this.noneSupportFlag = false;

      if (!snapshot || !snapshot.reason) return;

      if (snapshot.reason === "noAddress") {
        this.noneAddressFlag = true;
        this.textBuy = snapshot.textBuy || DS_NEED_ADDRESS_HINT;
        this.textCar = snapshot.textCar || DS_NEED_ADDRESS_HINT;
        this.cantBuy = false;
        return;
      }

      this.noneAddressFlag = false;

      if (snapshot.reason === "notSupport") {
        this.noneSupportFlag = true;
        this.textCar = snapshot.textCar;
        this.textBuy = snapshot.textBuy;
        this.currentRulesGroup = snapshot.currentRulesGroup || null;
        return;
      }

      this.currentRulesGroup = snapshot.currentRulesGroup;
      this.sendTypeColumns = snapshot.sendTypeColumns || [];
      this.sendSelectType = snapshot.sendSelectType || 0;
      this.deliveryInfo = snapshot.deliveryInfo || this.deliveryInfo;
      this.textCar = snapshot.textCar || "加入购物车";
      this.textBuy = snapshot.textBuy || "立即购买";

      const showAddcard = !!snapshot.showAddcard;
      if (this._openIntent === "addCart" && !showAddcard) {
        this.addCartShow = false;
        this.buyNowShow = true;
      } else if (this._openIntent === "addCart") {
        this.addCartShow = true;
        this.buyNowShow = false;
      } else if (this._openIntent === "buyNow") {
        this.addCartShow = false;
        this.buyNowShow = true;
      } else {
        this.addCartShow = showAddcard;
        this.buyNowShow = true;
      }
      this.showAddressBar = showAddcard ? 1 : 0;
      this.cantBuy = false;
    },

    async refreshDistributionRulesV2(spec = this.selectedSpec, quantity = this.payCount) {
      if (!spec || !spec.id) return;

      this.distributionRulesLock = true;
      this.cantBuy = true;
      let rulesRequestCompleted = false;
      try {
        const snapshot = await this.fetchDistributionRulesSnapshot(spec, quantity);
        rulesRequestCompleted = true;
        this.applyRulesSnapshot(snapshot);
        if (snapshot && snapshot.ok && snapshot.deliveryInfo && snapshot.deliveryInfo.shipType === "shop") {
          await this.loadShops();
        }
      } finally {
        this.distributionRulesLock = false;
        if (rulesRequestCompleted) {
          this._lastRulesRequestCompletedAt = Date.now();
        }
      }
    },

    /**
     * 仅用于「初次进入弹窗 / 切换地址后默认选中」的 sendTypeStr 文案兜底。
     * 用户主动通过 SendType picker 选择时，由 resolveDeliveryInfoFromPick 重新生成。
     *
     * 与 V2 接口字段一一对齐：
     *   - same:     仅运费
     *   - delivery: 日期 + 时段 + 当天运费
     *   - shop:     日期 + 时段
     */
    composeDefaultSendTypeStr(og, unit) {
      if (!og) return "";
      const safeUnit = unit || "点";
      const amt = og.deliveryAmount;
      if (og.shipType === "same") {
        return !amt || amt === "0" ? "快递配送 免运费" : `快递配送 运费${amt}${safeUnit}`;
      }
      if (og.shipType === "shop") {
        return `门店自提 ${og.shipDate || ""} ${og.shipTimeText || ""}`.replace(/\s+/g, " ").trim();
      }
      if (og.shipType === "delivery") {
        const head = `商家配送 ${og.shipDate || ""} ${og.shipTimeText || ""}`.replace(/\s+/g, " ").trim();
        return !amt || amt === "0" ? `${head} 免运费` : `${head} 运费${amt}${safeUnit}`;
      }
      return "";
    },

    handleOpenSendTypeClick() {
      if (this.noneSupportFlag) return;
      if (Array.isArray(this.sendTypeColumns) && this.sendTypeColumns.length > 0) {
        this.sendTypeShow = true;
      }
    },

    async handleTypeConfirm(record) {
      this.sendTypeShow = false;
      const unit = (this.detail && this.detail.cardPointTypeUnit) || "点";
      const og = this.currentRulesGroup ? this.currentRulesGroup.orderGroup : null;
      const info = resolveDeliveryInfoFromPick(record, og, unit);
      if (info && info.shipType) {
        this.deliveryInfo = {
          shipType: info.shipType,
          shipDate: info.shipDate,
          shipTimeText: info.shipTimeText,
          deliveryAmount: info.deliveryAmount,
          sendTypeStr: info.sendTypeStr,
        };
        this.sendSelectType = info.sendSelectType;
        if (info.shipType === "shop") {
          await this.loadShops();
        } else {
          this.shopList = [];
          this.shopInfo = null;
        }
      }
    },

    async loadShops() {
      const brandId = this.detail && this.detail.thirdBrandId;
      const cityId = this.detail && this.detail.cityId;
      if (!brandId || !cityId) {
        Toast("缺少信息，无法获取门店");
        return;
      }
      this.shopList = await loadV2Shops(brandId, cityId);
      if (Array.isArray(this.shopList) && this.shopList.length > 0 && !this.shopInfo) {
        // 默认选中第一个
        const first = this.shopList[0];
        this.shopInfo = {
          address: first.address,
          shopDetail: first.address,
          shopId: first.shop_id,
          shopName: first.shop_name,
        };
      }
    },

    handleSelectShopChange(record) {
      if (record) {
        this.shopInfo = {
          address: record.address,
          shopDetail: record.address,
          shopId: record.shop_id,
          shopName: record.shop_name,
        };
      }
      this.shopAddressShow = false;
    },

    /**
     * ChargeSelector @change 回调：记录用户选中的附件（仅含 quantity>0 的条目）。
     * 提交时拆分为 chargeIds / chargeQuantities 透传到 V2 下单接口。
     */
    handleChargeChange(payload) {
      this.chargeSelections = (payload && Array.isArray(payload.selected)) ? payload.selected : [];
    },

    /**
     * 规格列表就绪（watch loadAfter）：只同步选中项，不在这里调配送规则。
     * 原因：有缓存地址时若此处 refresh，会与随后 ensureDefaultSynced → loadAfter 重复打 queryDistributionRulesV2（立即购买必现 2 次）。
     * 例外：地址已就绪但此前尚无规格 id（极少），补拉一次。
     */
    handleSpecListReady(record) {
      const prevId = this.selectedSpec && this.selectedSpec.id;
      this.selectedSpec = record || {};
      this.payCount = 1;
      this.applyTasteOptionsForSpec(this.selectedSpec);
      this.$emit("specChange", { selectedSpec: this.selectedSpec, count: this.payCount });
      if (!this.popupShow || !this.selectedSpec.id) return;
      if (!this.addressInfo.addressId) return;
      if (!prevId) {
        this.scheduleUserTriggeredRulesRefresh();
      }
    },

    /** 用户点击切换规格 */
    async handleSpecUserChange(record) {
      const nextSpec = record || {};
      if (!nextSpec.id) return;
      if (this.isSameSpec(nextSpec, this.selectedSpec)) {
        return;
      }
      if (this.distributionRulesLock) {
        Toast("正在获取配送规则，请稍等～");
        return;
      }

      this.cancelPendingUserRulesRefresh();
      this.distributionRulesLock = true;
      this.cantBuy = true;
      let rulesRequestCompleted = false;
      try {
        const nextCount = 1;
        const snapshot = await this.fetchDistributionRulesSnapshot(nextSpec, nextCount);
        rulesRequestCompleted = true;
        // 先有规则结果，再更新规格相关 UI，避免先展示后回滚的闪烁
        this.selectedSpec = nextSpec;
        this.payCount = nextCount;
        this.applyTasteOptionsForSpec(this.selectedSpec);
        this.$emit("specChange", { selectedSpec: this.selectedSpec, count: this.payCount });
        this.applyRulesSnapshot(snapshot);
        if (snapshot && snapshot.ok && snapshot.deliveryInfo && snapshot.deliveryInfo.shipType === "shop") {
          await this.loadShops();
        }
      } finally {
        this.distributionRulesLock = false;
        if (rulesRequestCompleted) {
          this._lastRulesRequestCompletedAt = Date.now();
        }
      }
    },

    /**
     * 根据当前 selectedSpec 解析口味候选列表 + 默认选中策略。
     * - 无 tastes 字段：清空 tasteOptions / selectedTaste
     * - 单条：tasteOptions=[t]，selectedTaste=t（自动选中且 UI 禁切换）
     * - 多条：tasteOptions=[...]，selectedTaste="" 由用户手动单选
     */
    applyTasteOptionsForSpec(spec) {
      const raw = spec && spec.tastes ? String(spec.tastes) : "";
      if (!raw) {
        this.tasteOptions = [];
        this.selectedTaste = "";
        return;
      }
      const opts = raw.split(",").map(s => s.trim()).filter(s => !!s);
      this.tasteOptions = opts;
      if (opts.length === 1) {
        this.selectedTaste = opts[0];
      } else {
        this.selectedTaste = "";
      }
    },

    /** 用户点击口味（多条情况下单选；单条情况点击不响应） */
    handleTasteClick(t) {
      if (!t) return;
      if (this.tasteOptions.length === 1) return; // 单条默认选中且禁切换
      this.selectedTaste = t;
    },

    handleOverlimit() {
      if (this.payCount <= 1) {
        Toast("购买数量最少1件");
      }
    },

    onChange() {
      this.scheduleUserTriggeredRulesRefresh();
    },

    handleAddMyCartClick() {
      if (!this.canSubmit("addCart")) return;
      this.onSubmit("addMyCart");
    },

    handlebuyNowClick() {
      if (!this.canSubmit("buyNow")) return;
      this.onSubmit("buyNow");
    },

    /**
     * 提交前的统一校验
     */
    canSubmit(intent) {
      if (this.distributionRulesLock) {
        Toast("正在获取配送规则，请稍等～");
        return false;
      }
      // 蛋叔（DS 前缀）商品：无地址时加购/立即购统一提示并打开地址选择
      if ((intent === "buyNow" || intent === "addCart") && this.isDsChannelProduct && !this.addressInfo.addressId) {
        this.handleAddressOpen(1);
        return false;
      }
      if (this.noneSupportFlag) {
        Toast("当前地址不支持配送");
        return false;
      }
      if (this.sendSelectType === 1 && (!this.shopInfo || !this.shopInfo.shopId)) {
        Toast("请选择商家地址");
        return false;
      }
      // 多条口味时必须用户主动选一条；单条已默认选中
      if (this.tasteOptions.length > 1 && !this.selectedTaste) {
        Toast("请选择口味");
        return false;
      }
      return true;
    },

    onSubmit(type) {
      const chargeIds = this.chargeSelections.map(c => c.chargeId);
      const chargeQuantities = this.chargeSelections.map(c => c.quantity);
      this.$emit("submit", {
        type, // "addMyCart" | "buyNow"
        selectedSpec: { ...this.selectedSpec, count: this.payCount },
        deliveryData: {
          addressInfo: this.addressInfo,
          shopInfo: this.shopInfo,
          deliveryInfo: this.deliveryInfo,
          sendSelectType: this.sendSelectType,
          leaveWordText: this.leaveWordText,
          notesText: this.notesText,
          showAddressBar: this.showAddressBar,
          // 附件快照：透传到 detailsDsV2.action.js#submitBuyGoodsInfoDsV2 → ProductSubOrderDTO
          chargeIds,
          chargeQuantities,
          // 口味
          tastesName: this.selectedTaste || "",
        },
      });
      this.popupShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index";

/* 蛋叔 V2 — 口味 / 赠品 / 规格描述（辅助展示）样式，单独维护，避免污染老的 SpecPopup 样式表 */
.aux-text {
  font-size: 12px;
  color: #737376;
  line-height: 1.5;
  padding: 2px 0 4px;
  white-space: pre-wrap;
  word-break: break-all;
}

/* 配送方式 van-cell #label：delivery_text 小号灰色辅文 */
.spec-cell-delivery-note {
  font-size: 11px;
  line-height: 1.35;
  color: #969799;
  margin-top: 2px;
  padding-right: 8px;
  white-space: pre-wrap;
  word-break: break-word;
}

.taste-list {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  padding: 2px 0 4px;

  .taste-item {
    box-sizing: border-box;
    display: inline-block;
    padding: 3px 10px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    font-size: 12px;
    color: #333;
    background: #f7f7f7;
    line-height: 1.35;
  }
  .taste-item-selected {
    color: rgb(255, 80, 0);
    border-color: rgb(255, 80, 0);
    background: #fff4ec;
  }
  .taste-item-readonly {
    /* 单条默认选中，禁切换：颜色保持选中态 + 鼠标禁用 */
    cursor: default;
  }
}

:deep(.spec-lump-wrapper) {
  padding: 2vw 0;
}

:deep(.address-warpper .address-title) {
  padding: 1.6vw 0;
  line-height: 1.3;
}
</style>
